import http, { url } from '../../http'

const API_URL = "profiles_job_description"

class perfilesCargoAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAllExcel(id, initial, end_date) {
    const response = await http(`${API_URL}/${id}?&initial_date=${initial}&end_date=${end_date}`)
    return response
  }

  async getAll(id, resource) {
    const response = await http(`${API_URL}/index/${id}`, 'POST', resource)
    return response
  }

  async get(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST', resource)
    return response
  }

  async getTypes() {
    const response = await http(`${API_URL}/evaluations_types`)
    return response
  }


  async saveY(resource) {
    const response = await http(`${API_URL}/report`, 'POST', resource)
    return response
  }

  async saveM(resource) {
    const response = await http(`${API_URL}/report/month`, 'POST', resource)
    return response
  }

  async saveYears(resource) {
    const response = await http(`${API_URL}/between_years`, 'POST', resource)
    return response
  }

  async show(id) {
    const response = await http(`${API_URL}/show/${id}`)
    return response
  }



  /*   async getAll(page) {
      const response = await http(`${API_URL}?page=${page}`)
      return response
    } 
   */
/*   async getAll(id, page, search) {
    const response = await http(`${API_URL}/index/${id}?page=${page}&search=${search}`, 'POST')
    return response
  } */

  /*   async getAll(id, page) {
      const response = await http(`${API_URL}/companies/${id}?page=${page}`)
      return response
    }  */

  async get(id) {
    const response = await http(`${API_URL}/index/${id}`, 'POST')
    return response
  }
  /* 
    async getExcel(id) {
      const response = url(`${API_URL}/excelAdvance/${id}`)
      return response
    }  */

  async getExcel(companyId) {
    let user = JSON.parse(localStorage.getItem('user'))

    if (user.token) {
      return url(`${API_URL}/report/${companyId}?&access_token=${user.token}`)
    }


    /*     let user = JSON.parse(localStorage.getItem('user'))
      const response = url(`${API_URL}/excelAdvance/${id}`, {
        access_token: user.token,
      }) */
  }


  async getShow(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async updateE(id, resource) {
    const response = await http(`profiles_job_description/update_evaluation/${id}`, 'PUT', resource)
    return response
  }

  async delete(id, companies_id) {
    const response = await http(`${API_URL}/delete/${id}/${companies_id}`, 'DELETE')
    return response
  }

}

export default new perfilesCargoAPI()